import { combineReducers } from 'redux';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import reduce from 'lodash/reduce';
import sum from 'lodash/sum';
import moment from 'moment';
import config from '../../../../config';
import * as types from '../constants';

const makeDetails = (rows) => {
  return groupBy(rows, (row) => {
    return moment(row.fromDate).format(config.dateFormatISO);
  });
};

export const makeSummary = (rows) => {
  const details = makeDetails(rows);

  return map(details, (byDate) => {
    return reduce(byDate, (result, row) => {
      if (row.transferredToBarber) {
        result.barberAmount += sum([
          row.servicesRevenue,
          row.productsRevenue,
          row.servicesInstantPayoutFee,
          row.productsInstantPayoutFee,
        ]);

        result.barberDeposited += sum([
          row.servicesRevenue,
          row.productsRevenue,
        ]);
      }

      if (row.barberId || row.unassigned) {
        result.shopAmount += sum([
          row.productsDueToShop,
          row.servicesDueToShop,
          row.totalProductsTaxAmount,
          row.totalServicesTaxAmount,
        ]);
      }

      if (!result.transferDate) {
        result.transferDate = row.createdAt;
        result.fromDate = row.fromDate;
        result.toDate = row.toDate;
      }

      if (row.tips) {
        result.tipsDeposited += row.tips.totalDeposited;
      }

      return result;
    }, {
      transferDate: null,
      fromDate: null,
      toDate: null,
      shopAmount: 0,
      barberAmount: 0,
      tipsDeposited: 0,
      barberDeposited: 0,
    });
  });
};

const summary = (state = {}, { type, payload}) => {
  switch (type) {
    case types.FETCH_PAYOUT_HISTORY:
      return makeSummary(payload);
    default:
      return state;
  }
};

const details = (state = {}, { type, payload}) => {
  switch (type) {
    case types.FETCH_PAYOUT_HISTORY:
      return makeDetails(payload);
    default:
      return state;
  }
};

export default combineReducers({
  summary,
  details,
});
